export const currentLoading = ( state ) => {
    return state.loading
}

export const getToast = (state) => {
    return state.toast
}